import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Popup from './popup';
import Calendar from './calendar';
import Calendar3Icon from '../../common/icons/calendar3.svg';
import './dateinput.scss';
import './input/index.scss';

export default class DateInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            inputId: props.id ? props.id : Math.round(Math.random() * 10000)
        };

        this.onHide = this.onHide.bind(this);
        this.onChange = this.onChange.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.timeout = undefined;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.value !== this.props.value || nextState.visible !== this.state.visible;
    }

    isMobile() {
        if (this.props.isMobile !== undefined) {
            return this.props.isMobile;
        }

        let el = this.inputControl;
        while (el) {
            const classes = el.className.split(' ');
            if (classes.indexOf('mobile') >= 0) return true;
            el = el.parentElement;
        }
        return false;
    }

    onHide(e) {
        if (this.inputControl && !this.inputControl.contains(e.target)) {
            this.hidePopup();
        }
    }

    onChange(e) {
        if (e === undefined) {
            this.timeout = setTimeout(this.hidePopup, 150);
        } else {
            this.props.onChange(e);
        }
    }

    getValue() {
        if (this.props.format && this.props.value)
            return moment(this.props.value).format(this.props.format);
        else return this.props.value;
    }

    showPopup() {
        this.setState({ visible: true });
    }

    hidePopup() {
        this.setState({ visible: false });
    }

    togglePopup() {
        if (!this.state.visible) {
            if (
                this.props.autoSelectDay &&
                !this.getValue() &&
                this.props.intervals &&
                this.props.intervals.length > 0 &&
                this.props.onChange
            ) {
                this.props.onChange(this.props.intervals[0].cmbDelayedIntervalId);
            }
            this.showPopup();
        } else {
            this.hidePopup();
        }
    }

    render() {
        const props = this.props;
        const id = props.id || 'dateinput' + this.state.inputId;
        const value = this.getValue();

        return (
            <span className="dateinput" ref={el => (this.controlContainer = el)}>
                {this.props.icon && (
                    <label htmlFor={id} className="dateinput-label">
                        <Calendar3Icon />
                    </label>
                )}
                <input
                    id={id}
                    ref={el => (this.inputControl = el)}
                    className={`inp ${props.className ? props.className : ''} ${
                        this.state.visible ? 'opened' : ''
                    }`}
                    type={'text'}
                    value={value || ''}
                    onFocus={() => {
                        this.togglePopup();
                    }}
                    onMouseDown={e => {
                        if (e.target === document.activeElement) {
                            this.togglePopup();
                        } else {
                            e.target.focus();
                        }
                    }}
                    onBlur={e => {
                        e.preventDefault();
                    }}
                    onKeyDown={e => {
                        if ((e.which || e.keyCode) == 9) {
                            this.hidePopup();
                        }
                    }}
                    placeholder={props.placeholder}
                    autoComplete="off"
                    readOnly={true}
                />
                <Popup
                    className={`calendar-container default opl-sg ${
                        this.isMobile() ? 'mobile' : ''
                    }`}
                    visible={this.state.visible}
                    style={this.state.popupStyle}
                    onHide={this.onHide}
                    relativeTo={this.inputControl}
                    fullScreen={this.isMobile()}
                >
                    <Calendar
                        intervals={props.intervals}
                        value={props.value}
                        popup={true}
                        onChange={this.onChange}
                        onTimeChange={this.onHide}
                        onGoBack={this.hidePopup}
                        isMobile={this.isMobile()}
                    />
                </Popup>
            </span>
        );
    }
}

DateInput.defaultProps = {
    intervals: [],
    icon: false,
    autoSelectDay: false,
    hideOnTimeSelect: false, // not working yet
    isMobile: undefined
};

DateInput.propTypes = {
    onChange: PropTypes.func,
    isMobile: PropTypes.bool,
    intervals: PropTypes.array,
    value: PropTypes.string,
    format: PropTypes.string,
    icon: PropTypes.bool,
    autoSelectDay: PropTypes.bool,
    hideOnTimeSelect: PropTypes.bool, // not working yet
    placeholder: PropTypes.string,
    className: PropTypes.string
};
